
// 过滤ts类型验证
// @ts-nocheck
import { Options, Vue } from "vue-class-component";
import { getNewVersion } from "../../api/modules/download.js";

@Options({
  data() {
    return {
      list: [
        {
          name: "闪店-嵌入版",
          apply: "Win7及以上版本/Win Vista SP2",
          require: "Net Framework4.5.2",
          editionName: "",
          url: "",
          desc: "",
          btnTxt: "下载",
          update: "",
        },{
          name: "闪店-浏览器版本",
          apply: "Win10及以上版本/Win Vista SP2",
          require: "Net Framework4.5.2",
          editionName: "",
          url: "",
          desc: "",
          btnTxt: "下载",
          update: "",
        },

        {
          name: "For Mac",
          apply: "Mac OS X 10.10 Yosemite及以上版本",
          require: "",
          editionName: "敬请期待",
          url: "",
          desc: "闪店-体验版",
          btnTxt: "敬请期待",
        },
        {
          name: "组件下载",
          // apply: "",
          // require: "Net Framework4.5.2",
          editionName:
            "当浏览器运行时提示计算机中缺少运行库时，请下载此文件并安装",
          url: window.location.protocol + '//' + window.location.host + "/download/VC_redist.x64.exe",
          desc: "VC_redist.x64.exe",
          btnTxt: "下载",
          update: "2021.03.08",
        },
      ],
    };
  },
  mounted() {
    this.getDownloadInfo();
  },
  methods: {
    getDownloadInfo() {
      const params = {
        appName: "SilverStoreMsi",
        endpoint: window.location.protocol + '//' + window.location.host
      };
      getNewVersion(params).then((response) => {
        this.list[0].url = response.data[0].url;
        this.list[0].update = response.data[0].updateTime;
        this.list[0].editionName = response.data[0].version;
      });

      const params1 = {
        appName: "SilverBrowserMsi",
        endpoint: window.location.protocol + '//' + window.location.host
      };
      getNewVersion(params1).then((response) => {
        this.list[1].url = response.data[0].url;
        this.list[1].update = response.data[0].updateTime;
        this.list[1].editionName = response.data[0].version;
      });

    },
  },
})
export default class Header extends Vue {}
